export default __webpack_public_path__ + "8b7f759195e88eaebb71256f56c11fa4.jpg";